import { FormControl, Validators } from '@angular/forms';

export class ConfirmPasswordControl extends FormControl {
  constructor() {
    super('');
    this.addValidator();
  }

  private addValidator() {
    this.setValidators([
      Validators.required,
      Validators.maxLength(20),
      Validators.minLength(12),
      Validators.pattern(/^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{0,100}$/)
    ]);
  }
}
